"use strict";

var _slicedToArray = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("./react");

var isClient = typeof window === 'object';

var useLocalStorage = function useLocalStorage(key, initialValue, raw) {
  if (!isClient) {
    return [initialValue, function () {}];
  }

  var _react_1$useState = react_1.useState(function () {
    try {
      var localStorageValue = localStorage.getItem(key);

      if (typeof localStorageValue !== 'string') {
        localStorage.setItem(key, raw ? String(initialValue) : JSON.stringify(initialValue));
        return initialValue;
      } else {
        return raw ? localStorageValue : JSON.parse(localStorageValue || 'null');
      }
    } catch (_a) {
      // If user is in private mode or has storage restriction
      // localStorage can throw. JSON.parse and JSON.stringify
      // cat throw, too.
      return initialValue;
    }
  }),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      state = _react_1$useState2[0],
      setState = _react_1$useState2[1];

  react_1.useEffect(function () {
    try {
      var serializedState = raw ? String(state) : JSON.stringify(state);
      localStorage.setItem(key, serializedState);
    } catch (_a) {// If user is in private mode or has storage restriction
      // localStorage can throw. Also JSON.stringify can throw.
    }
  });
  return [state, setState];
};

exports.default = useLocalStorage;